import React 				from 'react';
import BLComponent			from '../../core/_BLComponent.jsx';
import MyCollectionProtocol from '../controller/MyCollectionProtocol.js';
import Modal 				from '../../modals/_DynamicModal.jsx';

import PartOutModalBody		from './_PartOutModalBody.jsx';

export default class PartOutModal extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 

		this.state	= 	{
			isOptionSaved: false
		,	partoutOptions:{incRegularParts:false, incExtraParts: false, breakMinifig: false}
		,	partoutOptionsSimple: {incRegularParts: true, incExtraParts: true, breakMinifig: false}
		,	partoutOrig:{incRegularParts:false, incExtraParts: false, breakMinifig: false}
		,	status: 1 // 1: partout modal body, 2, 4: partout on going, 3 : first error, 4 : final error, 99: succeed
		,	itemInvData: this.props.data.itemInvData
		};
	}

	componentDidMount() 
	{
	}

	updatePartout(type) {
		let partoutOptions = this.getPartOutOptions();
		switch(type) {
			case "r" :  partoutOptions.incRegularParts = !partoutOptions.incRegularParts;
						break;
			case "e" :  partoutOptions.incExtraParts = !partoutOptions.incExtraParts;
						break;
			case "m" :  partoutOptions.breakMinifig = !partoutOptions.breakMinifig;
						break;
		}
		this.setState({partoutOptions:partoutOptions});
	}

	
	isAnyOptionsChanged() {
		const partoutOptions = this.getPartOutOptions();
		const partoutOrig = this.state.partoutOrig;

		return ( (partoutOrig.incRegularParts != partoutOptions.incRegularParts) || 
				 (partoutOrig.incExtraParts != partoutOptions.incExtraParts) || 
				 (partoutOrig.breakMinifig != partoutOptions.breakMinifig ) );

	}

	isEnablePartOutSaveButton() {
		const {itemType} = this.props.data;
		const partoutOptions = this.getPartOutOptions();
		if (itemType == "M") return true;
		return ( partoutOptions.incRegularParts || partoutOptions.incExtraParts || partoutOptions.breakMinifig )
	}

	render() {
		const {itemType} = this.props.data;
		const partoutOptions = this.getPartOutOptions();
		const partOutModalBody = () => {
			return ( 
				<PartOutModalBody 
					data={ {itemName: this.props.data.itemName, itemType: itemType, statusPartOut: this.state.status, itemInvData: this.state.itemInvData } }
					func={this.props.func} 
					updatePartout={(type)=>this.updatePartout(type)} 
					partoutOptions={partoutOptions}/>
			)
		}
		const ModalFooterButtons = this.getModalFooterButtons();
		const modalOption = {
			title: { name: this.props.data.title, showClose: true, display: true, clickable: true /*, callback:()=>{this.clickTitle()}*/ }
		,	showCloseButton: false
		,	closeOnEscape: true
		,	modalSize: "s" /* s m l */
		,	ModalBody: partOutModalBody
		,	ModalFooter: {
				buttons: ModalFooterButtons
			,	dontshowagain: { msg:"Don't show again", display: false, func:()=>{this.dontshowagain()}}
			}
		,	closeFunc: ()=>this.toggleModal()
		}

		return (
			<Modal data={ modalOption }/>
		)
	}

	toggleModal() {
		const {idx} = this.props.data;
		this.props.func.reloadTriggerOn();
		this.props.func.closePartOutModal(idx, this.state.status);
	}

	savePartOutOptions()
	{
		const partoutOptions = this.getPartOutOptions();
		const status = this.state.status + 1;
		this.setState( {status: status}, this.partoutProcess() );
	}

	cancelPartOut() {
		this.toggleModal();
	}

	getPartOutOptions() {
		const {itemType} = this.props.data;
		
		if ( (itemType == "minifigure") || (itemType == "catalog") ) {
			return {incRegularParts:true, incExtraParts:false, breakMinifig:false}
		}
		else {
			return this.state.partoutOptions;
		}
	}

	getModalFooterButtons() {		
		const statusPartOut = this.state.status;
		const disabled = !this.isEnablePartOutSaveButton();
		const saveButton = {
			direction: "row"
		,	list: [
						{ name: "Add to My Parts", class: "text--bold btn--cta", disabled: disabled, func:()=>{this.savePartOutOptions()}}
			]
		}
		const retryButton = {
			direction: "row"
		,	list: [
						{ name: "Cancel", class: "", disabled: false, func:()=>{this.cancelPartOut()}}
					,	{ name: "Try again", class: "text--bold btn--cta", disabled: false, func:()=>{this.savePartOutOptions()}}
			]
		}
		const doneButton = {
			direction: "row"
		,	list: [
						{ name: "Done", class: "text--bold btn--cta", disabled: false, func:()=>{this.cancelPartOut()}}
			]
		}
		
		if (statusPartOut == 1) {
			return saveButton;
		}
		if (statusPartOut == 3) {
			return retryButton;
		}
		if (statusPartOut == 5) {
			return doneButton;
		}
		return {}
	}

	partoutProcess() {
		// Request to Save
		const { itemType, item } = this.props.data;
		const itemAdded = [item];
		let arrAddedItem = [];
		const partoutOptions = (itemType == "M")?this.state.partoutOptionsSimple:this.state.partoutOptions;
		const isPartout = (partoutOptions.incRegularParts || partoutOptions.breakMinifig || partoutOptions.incExtraParts)?true:false;		
		const incRegularParts = partoutOptions.incRegularParts;
		const incExtraParts = partoutOptions.incExtraParts;
		const breakMinifig = partoutOptions.breakMinifig;

		for (const item of itemAdded) {
			if (item.filled == true) {
				const partout = (item.partout.incRegularParts || item.partout.incExtraParts)?true:false;
			
				arrAddedItem[arrAddedItem.length] = { itemType: itemType, itemId: item.itemId, itemCondition: parseInt(item.condition), qty: item.qty, partout: isPartout, includeRegular: incRegularParts, includeExtra: incExtraParts, breakMinifigure: breakMinifig, itemNote: "" };
				if (item.idColor >= 0) arrAddedItem[arrAddedItem.length - 1].colorId = item.idColor;
			}

		}

		MyCollectionProtocol.reqAddItems(
			arrAddedItem
		).then(
			(data) => {
				if (data != null) {
					this.setState({status:99});
				}
			}
		).catch(
			(err) => {
				const status = this.state.status + 1;
				this.setState({status:status});
				
			}

		)
	}

};

